import React from 'react';

interface IProps {
	children: React.ReactNode;
	testId: string;
}

export const ListingContent: React.FC<IProps> = ({ children, testId }) => (
	<div className="flex flex-col gap-8" data-test={testId}>
		{children}
	</div>
);
